




















import {
  defineComponent,
} from '@vue/composition-api';

const FileInput = defineComponent({
  props: {
    acceptedFiles: { // csv, mime or .ext ie: image/*,application/pdf,.psd
      type: String,
      default: null,
    },
    label: {},
    labelClass: { type: String, default: '' },
    multiple: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    asterisk: { type: Boolean, default: true },
    modelValue: {},
    ext: {},
    fileName: {},
  },
  setup(props, { emit }) {
    const reader = new FileReader();
    reader.onload = () => emit('blobUrl', reader.result);

    function updateFileHandler($event: any) {
      const { files } = $event.target;
      if (props.multiple) {
        const names: string[] = [];
        const extensions: string[] = [];
        const blobs: string[] = [];
        files.forEach((file: File) => {
          const ext = file.name.slice((Math.max(0, file.name.lastIndexOf('.')) || Infinity) + 1);
          names.push(file.name.replace(`.${ext}`, ''));
          extensions.push(ext);
        });
        emit('input', files);
        emit('update:fileName', names);
        emit('update:ext', extensions);
      } else {
        const ext = files[0].name.slice((Math.max(0, files[0].name.lastIndexOf('.')) || Infinity) + 1);
        emit('input', files[0]);
        emit('update:fileName', files[0].name.replace(`.${ext}`, ''));
        emit('update:ext', ext);

        reader.readAsDataURL(files[0]);
      }
    }

    return {
      updateFileHandler,
    };
  },
});

export default FileInput;
